export const isValidJSON = arg =>
  typeof arg === 'object' && arg !== null && !(arg instanceof Map) && !(arg instanceof Set);
